export function maskIdCard(idcard) {
  if (!idcard) return '';
  if (idcard.length < 8) return idcard;
  return idcard.slice(0, 4) + '**********' + idcard.slice(-4);
}



// WEBPACK FOOTER //
// ./src/utils/idcard.js